export enum BetStatus {
    New = 0,
    Cancelled
}